export const environment = {
  formats: {
    date: {
      table: "YYYY-MM-DD",
    },
    datetime: {
      table: "YYYY MMM DD : HH:mm a",
    },
  },
  regex: {
    nic: /^([0-9]{9}[x|X|v|V]|[0-9]{12})$/,
    // phone: /^(?:0|94|\\+94|0094)?(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|91)([0234579])|7([0125678])\\d)\\d{6}$/,
    phone: /^\d{9,}$/,
    passwordStrong: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\\S+$).{8,}$/,
    passwordNormal: /.{8}/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    // eslint-disable-next-line no-useless-escape
    url: /(\b(https?|http)):\/\/.[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i,
    domain: /^[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i,
    subDomain: /^[-a-zA-Z0-9@:%_+~#=]{2,256}$/i
  },
  parentDomainName: "klass.lk",
};
